import React, { useMemo, useState, useEffect } from 'react';
import { MantineReactTable } from 'mantine-react-table';
import { useTheme } from '../../../ThemeContext'; // Adjust the path as necessary
import { MantineProvider, Modal, Button, Loader, Text } from '@mantine/core';
import { getAllDangerPrediction, deleteDangerPrediction, deleteFile } from '../../../api/api';
import VibrationSimulationForm from '../Forms/Danger'; // Assuming the form component is imported
import { EyeIcon, TrashIcon, PencilIcon } from '@heroicons/react/24/outline';
import ConfirmationModal from '../../ConfirmationModal';


const VibrationSimulation = () => {
  const { theme } = useTheme(); // Get the theme from context
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false); // Loader state
  const [isOpen, setIsOpen] = useState(false); // Manage modal visibility
  const [update,setUpdate]=useState(false); // Update
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const handleOpen = () => {
    setEditData({}); // Reset editData when adding new data
    setIsOpen(true);
  }; // Open modal
  const handleClose = () => setIsOpen(false); // Close modal
const handleUpdate=()=>{
  setUpdate(!update);
}
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const res = await getAllDangerPrediction();
        setData(res.data); // Set data from API response
        console.log(res.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      setLoading(false); // Set loading to false once data is fetched
    };
    fetchData();
  }, [update]);

  const columns = useMemo(() => [
    {
      accessorKey: 'project_id.project_name',
      header: 'Project Name',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'siteEngineerName',
      header: 'Site Engineer Name',
    },
    {
      accessorKey: 'inspectorName',
      header: 'Inspector Name',
    },
    {
      accessorKey: 'vibrationSimulation',
      header: 'Vibration Simulation',
      Cell: ({ cell }) => (cell.getValue()==='true' ? 'Yes' : 'No'),
    },
    {
      accessorKey: 'wavePropagationSimulation',
      header: 'Wave Propagation Simulation',
      Cell: ({ cell }) => (cell.getValue()==='true'? 'Yes' : 'No'),
    },
    {
      accessorKey: 'liquefactionAnalysis',
      header: 'Liquefaction Analysis',
      Cell: ({ cell }) => (cell.getValue()==='true' ?'Yes' : 'No'),
    },
    {
      accessorKey: 'checklist',
      header: 'Checklist',
      Cell: ({ cell }) => cell.getValue() || 'N/A',
    },
    {
      accessorKey: 'comment',
      header: 'Comments',
    },
  {
    accessorKey: 'actions',
    header: 'Actions',
    Cell: ({ row }) => (
      <div className="flex space-x-2">
        <PencilIcon
          className="w-5 h-5 text-blue-600 hover:text-blue-800 cursor-pointer"
          onClick={() => handleEditRow(row)}
        />

        <TrashIcon
          className="w-5 h-5 text-red-600 hover:text-red-800 cursor-pointer"
          onClick={() => openDeleteConfirmation(row)}
        />
      </div>
    ),
  },
], []);

const openDeleteConfirmation = (row) => {
  setEditData(row.original);
  setConfirmModalOpen(true);
};

const handleDeleteRow = async () => {
    console.log(editData._id);
    if (editData) {
      try {
        await deleteDangerPrediction(editData._id);
        setConfirmModalOpen(false);
        handleUpdate();
        setEditData(false)
      } catch (error) {
        console.error('Error deleting project:', error);
      }
    }
  };

const handleEditRow = (row) => {
  setEditData(row.original);
  setIsOpen(true)
};
  return (
    <MantineProvider
      theme={{
        colorScheme: theme,
        primaryColor: 'blue',
        primaryShade: 5,
      }}
    >
       <div>
            <div className="flex justify-between items-center p-2 bg-gray-700 text-md">
              <Text className="text-xl font-semibold">Vibration Simulation</Text>
              <Button
                onClick={handleOpen}
                className="inline-flex justify-center rounded-md bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Add Data
              </Button>
            </div>
            </div>
      {/* Display the loader if data is being fetched */}
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Loader type="ThreeDots" color="#00BFFF" />
        </div>
      ) : (
        <>
         

            {/* Vibration Simulation Table */}
            <div className="overflow-x-auto">
              <MantineReactTable
                columns={columns}
                data={data}
                enableColumnActions
                enableColumnFilters
                enablePagination
                enableSorting
                enableRowNumbers
                enableGlobalFilter
                mantineTableProps={{
                  highlightOnHover: true,
                  withBorder: true,
                  sx: {
                    'thead > tr': {
                      backgroundColor: theme === 'dark' ? '#1a202c' : '#f7fafc',
                    },
                    'thead > tr > th': {
                      backgroundColor: theme === 'dark' ? '#2d3748' : '#edf2f7',
                      color: theme === 'dark' ? '#e2e8f0' : '#2d3748',
                    },
                    'tbody > tr': {
                      '&:hover': {
                        backgroundColor: theme === 'dark' ? '#2d3748' : '#f1f5f9',
                      },
                    },
                    'tbody > tr > td': {
                      backgroundColor: theme === 'dark' ? '#2d3748' : '#ffffff',
                      color: theme === 'dark' ? '#ffff' : '#333333',
                    },
                  },
                }}
              />
            </div>
             {/* Confirmation Modal */}
          <ConfirmationModal
            isOpen={confirmModalOpen}
            onClose={() => setConfirmModalOpen(false)}
            onConfirm={handleDeleteRow}
            title="Confirm Deletion"
            message="Are you sure you want to delete this?"
          />
            </>

      )}
        {/* Modal for Vibration Simulation Form */}
        {isOpen && (
              <VibrationSimulationForm onClose={handleClose} isOpen={isOpen} editData={editData} handleUpdate={handleUpdate}/>
            )}
    </MantineProvider>
  );
};

export default VibrationSimulation;
